import createGetFormInitialValues from './selectors/getFormInitialValues';
import plain from './structure/plain';

export default createGetFormInitialValues(plain);


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-form/es/getFormInitialValues.js
// module id = 483
// module chunks = 0